import React from 'react';
import { AuthWrapper } from '@/features/core/auth/screens/AuthWrapper';
import { Button } from '@/components/Button';

export const ContactsContainer: React.FC = () => {
  const supportUrl = 'https://suporte.bancadoingresso.com.br/open';

  return (
    <AuthWrapper isHomepage={false}>
      <div className="w-full bg-white font-dmsans min-h-[70vh]">
        <div className="container mx-auto px-4 pt-10 pb-20 max-w-4xl">
          {/* Header */}
          <div className="mb-10 border-b border-gray-100 pb-6">
            <h1 className="text-primary-500 text-3xl md:text-4xl font-bold">Contato e suporte</h1>
          </div>

          <div className="space-y-6">
            {/* Card: Atendimento ao Cliente */}
            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-primary-500/10 flex items-center justify-center text-primary-500 flex-shrink-0">
                  {/* Ícone de Chat */}
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                    />
                  </svg>
                </div>
                <div>
                  <h2 className="text-xl font-bold text-gray-900">Atendimento ao Cliente</h2>
                  <p className="text-gray-500 text-sm mt-1">
                    Acesse nossa central de suporte para abrir chamados e tirar suas dúvidas.
                  </p>
                </div>
              </div>

              <a
                href={supportUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full md:w-auto"
              >
                <Button
                  title="Acessar Suporte"
                  buttonStyle="primary"
                  size="lg"
                  className="w-full md:w-[200px] !bg-primary-500 hover:!bg-primary-600 text-white font-bold"
                  iconRight={
                    <svg
                      className="w-5 h-5 ml-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                  }
                />
              </a>
            </div>

            {/* Card: Horário de Funcionamento */}
            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
              <h2 className="text-xl font-bold text-gray-900 mb-3">Horário de funcionamento</h2>
              <div className="inline-flex items-center gap-2 px-3.5 py-1.5 bg-primary-500/10 text-primary-500 rounded-lg text-sm font-semibold mb-2">
                <span className="w-2.5 h-2.5 rounded-full bg-primary-500 animate-pulse" />
                Atendimento 24 Horas
              </div>
              <p className="text-gray-600 text-sm leading-relaxed">
                Segunda a Domingo — 24 horas por dia, 7 dias por semana.
              </p>
            </div>

            {/* Card: Endereço */}
            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
              <h2 className="text-xl font-bold text-gray-900 mb-2">Endereço</h2>
              <p className="text-gray-700 font-medium">Banca do Ingresso</p>
              <p className="text-gray-500 text-sm mt-1">
                Perimetral Leste, 577, Santa Fé do Sul - SP, Brasil
              </p>
            </div>
          </div>
        </div>
      </div>
    </AuthWrapper>
  );
};
